(function MediaHubDetails($, Adzuki)
{
	const component = {
		emits : ['close-details', 'deleted-media', 'selected-media', 'updated-media', 'update-media-clients', 'move-media'],
		inject: {
			fileIcon: {
				default: () => undefined
			},
			formatDate: {
				default: () => undefined
			},
			formatDuration: {
				default: () => undefined
			},
			formatFileSize: {
				default: () => undefined
			},
			openToast: {
				default: () => undefined
			},
			openAlert: {
				default: () => undefined
			},
			getSectionInfo: {
				default: () => undefined
			},
			normalizeExtension: {
				default: () => undefined
			},
			sendMediaToParent: {
				default: () => undefined
			},
			statusAction: {
				default: () => undefined
			},
			fileNameFromPath: {
				default: () => undefined
			},
			getMediaSrcString: {
				default: () => undefined
			},
			mediaAssetSrc: {
				default: () => (value) => {
					if (!value) {
						return '';
					}

					if ((/^https?:\/\//i).test(value)) {
						return value;
					}

					return value;
				}
			},
			onPrivateMediaImageError: {
				default: () => (item) => {
					Adzuki.MediaUrls.fallbackToProxy(item);
				}
			},
			onPrivateMediaThumbnailError: {
				default: () => (item) => {
					Adzuki.MediaUrls.fallbackThumbnailToProxy(item);
				}
			}
		},
		props: {
			media: {
				type    : Object,
				required: true,
				default : {}
			},
			sectionInfo: {
				type: Object,
			},
			viewElement: {
				type: String
			},
			// Manage Media's drawer (MEDIA-276); other callers leave these at their defaults
			attachedTo: {
				type   : Object,
				default: null,
			},
			canMove: {
				type   : Boolean,
				default: false,
			},
			moveLabel: {
				type   : String,
				default: '',
			},
		},
		template: '#mediahub-details-component',
		data() {
			return {
				showEdit      : false,
				showClientLink: false,
				showConfirm   : false,
				confirmMessage: '',
				mediaToDelete : null,
				updatedMedia  : this.media,
				imgHeight     : 0,
				showCropper   : false,
				uploadProps   : {},
				showPopForm   : false,
				popData       : {},
				showViewer    : false,
				viewerUrl     : '',
				editSnapshot  : null
			};
		},
		computed: {
			hasResizeDimensions() {
				return Number(this.sectionInfo.resize_width) > 0 || Number(this.sectionInfo.resize_height) > 0;
			},
			isImage() {
				return this.updatedMedia.type === 'image';
			},
			formattedStatus() {
				let status;
				let statusOptions= [
					{
						id  : 'restricted',
						name: 'Approved - Limited'
					},
					{
						id  : 'pending',
						name: 'Pending Unlimited Approval'
					},
					{
						id  : 'approved',
						name: 'Approved - Unlimited'
					}
				];

				status = statusOptions.find(option => option.id === this.updatedMedia.status);
				return status.name;
			},
			statusTooltip() {
				let statusDescription = '';

				switch (this.updatedMedia.status) {
					case 'restricted':
						statusDescription = 'This image can only be used within CP Maxx tools and must go through our approval process regardless of whether they meet AI and/or copyright criteria for Website Admin tools.';
						break;
					case 'pending':
						statusDescription = 'This image can be used within CP Maxx tools and is pending approval for use within Website Admin tools.';
						break;
					case 'approved':
						statusDescription = 'This image can be used for both CP Maxx tools and Website Admin tools.';
						break;
					default:
						statusDescription = '';
						break;
				}

				return statusDescription;
			}
		},
		methods: {
			copyUrl() {
				// Try modern clipboard API first
				if (navigator.clipboard && window.isSecureContext) {
					navigator.clipboard.writeText(this.media.remote_url)
						.then(() => {
							Adzuki.Toast('success', 'Link copied to your clipboard.');
						})
						.catch(err => {
							// Fall back to legacy method
							this.fallbackCopyTextToClipboard(this.media.remote_url);
						});
				} else {
					// Use legacy method directly
					this.fallbackCopyTextToClipboard(this.media.remote_url);
				}
			},
			fallbackCopyTextToClipboard(text) {
				const textArea = document.createElement("textarea");
				textArea.value = text;

				// Avoid scrolling to bottom
				textArea.style.top = "0";
				textArea.style.left = "0";
				textArea.style.position = "fixed";
				textArea.style.opacity = "0";

				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					document.execCommand('copy');

					Adzuki.Toast('success', 'Link copied to your clipboard.');
				} catch (err) {
					this.openAlert('error', 'Error', 'Copy not supported in this browser');
				}

				document.body.removeChild(textArea);
			},
			downloadFile() {
				window.location.href = this.$baseUri + '/Media/downloadMediaItem/' + encodeURIComponent(this.media.id);
			},
			aspectRatio(width, height) {
				return width / height;
			},
			closeDetails() {
				this.showClientLink = false;
				this.$emit('close-details');
			},
			closeEdit() {
				this.showEdit = false;
			},
			// the edit form's values when editing started, to spot unsaved changes
			// (MEDIA-277: closing the drawer with edits asks "Discard changes?")
			takeEditSnapshot() {
				const form = this.$refs.editForm;

				this.editSnapshot = form && form.fileForm ? JSON.stringify(form.fileForm) : null;
			},
			hasUnsavedEdits() {
				const form = this.$refs.editForm;

				if (!this.showEdit || !form || !form.fileForm || this.editSnapshot === null) {
					return false;
				}

				return JSON.stringify(form.fileForm) !== this.editSnapshot;
			},
			updateMedia(newMedia) {
				this.updatedMedia = newMedia;
				this.openAlert('success', 'Success', 'File details updated successfully');
				this.closeEdit();
				this.$emit('updated-media', this.updatedMedia);
			},
			deleteMedia() {
				this.confirmMessage = 'The file and every version saved for it are deleted. This can\'t be undone.';
				this.mediaToDelete = this.media;

				// same confirm Trip Summary uses (MEDIA-265)
				Adzuki.CustomConfirm.destructive({
					title           : 'Delete “' + Adzuki.CustomConfirm.escape(this.media.title || this.media.original_file_name || 'this file') + '”?',
					content         : this.confirmMessage,
					confirm_btn_text: 'Delete file',
					confirm         : () => this.confirmDelete(),
					cancel          : () => this.cancelDelete(),
				});
			},
			async checkMediaUsage(mediaId) {
				const formData = new FormData();
				formData.append('media_id', mediaId);

				const response = await fetch(`${this.$baseUri}/Media/determineUsage`, {
					method: 'POST',
					body  : formData,
				});

				if (!response.ok) {
					throw new Error(`Failed to check media usage: ${response.statusText}`);
				}

				return response.json();
			},
			async confirmDelete() {
				if (!this.mediaToDelete) {
					return;
				}

				try {
					const usage = await this.checkMediaUsage(this.mediaToDelete.id);
					console.log('Usage:', usage);
					if (usage.in_use) {
						this.openAlert('error', 'Cannot Delete', usage.message || 'This file is in use and cannot be deleted.');
						this.showConfirm = false;
						return;
					}
				} catch (error) {
					this.openAlert('error', 'Error', `An error occurred while checking file usage: ${error.message}`);
					this.showConfirm = false;
					return;
				}

				const url = `${this.$baseUri}/Media/deleteMediaItem/${this.media.id}/1`;

				fetch(url)
						.then(response => {
							if (!response.ok) {
								throw new Error(`${response.statusText}`);
							}
							return response.json();
						})
						.then(data => {
						if (data.status === 'success') {
							this.openAlert('success', 'Success', 'File successfully deleted');
							this.$emit('deleted-media');
						} else {
							this.openAlert('error', 'Error', data.message || 'Unable to delete this file.');
						}
					})
					.catch(error => {
						console.error('Error deleting media:', error);
						this.openAlert('error', 'Error', 'An error occurred while deleting this file.');
					});
			},
			cancelDelete() {
				this.showConfirm   = false;
				this.mediaToDelete = null;
			},
			needsPublicUrlLookup(url) {
				if (!url || !url.includes('cpmaxxmediaprivate')) {
					return false;
				}

				return !(/[?&](Signature|X-Amz-Signature)=/).test(url);
			},
			closeViewer() {
				this.showViewer = false;
				this.viewerUrl  = '';
			},
			openExternalUrl(url) {
				const media = this.updatedMedia || this.media;
				let iosHandler;
				let tab;

				if (!url) {
					this.openAlert('error', 'Error', 'Unable to determine the location of this file.');
					return;
				}

				if (window.appInterface && typeof window.appInterface.postMessage === 'function') {
					window.appInterface.postMessage(url);
					return;
				}

				iosHandler = window.webkit
					&& window.webkit.messageHandlers
					&& window.webkit.messageHandlers.onClick;

				if (iosHandler && typeof iosHandler.postMessage === 'function') {
					iosHandler.postMessage(url);
					return;
				}

				// 'noopener' would make this return null even when the tab opens,
				// and that return value is how we detect a WebView that cannot open one
				tab = window.open(url, '_blank');

				if (tab) {
					return;
				}

				// No new tab and no native bridge means a single-page app WebView. Navigating it
				// would replace Media Hub, so images and video open over the details card instead.
				if (media.type === 'image' || media.type === 'video') {
					this.viewerUrl  = url;
					this.showViewer = true;
					return;
				}

				this.downloadFile();
			},
			viewFile() {
				const media = this.updatedMedia || this.media;

				if (!this.needsPublicUrlLookup(media.remote_url)) {
					this.openExternalUrl(this.resolveMediaUrl(media));
					return;
				}

				fetch(`${this.$baseUri}/Media/getPublicMediaUrl/${media.id}`)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error getting public url: ${response.statusText}`);
						}

						return response.json();
					})
					.then(data => {
						if (data.status === 'error') {
							throw new Error(data.message || 'Unable to open this file.');
						}

						this.openExternalUrl(data.remote_url);
					})
					.catch(error => {
						console.error('Error getting public media url:', error);
						this.openAlert('error', 'Error', error.message || 'Unable to open this file.');
					});
			},
			needsPopFormForPending(data) {
				return Number(this.sectionInfo?.needs_approval) === 1 && Number(data.matches_found) === 1;
			},
			/**
			 * True when this section needs a cropped version and the media does not
			 * yet have a distinct section object (missing version, or metadata-only
			 * row that still points at the library remote_url).
			 */
			sectionVersionNeedsCrop(media) {
				if (!this.sectionInfo || !this.hasResizeDimensions) {
					return false;
				}

				const sectionId = Number(this.sectionInfo.id);

				if (Number(media.media_section_id) === sectionId) {
					return false;
				}

				const version = (media.versions || []).find(
					(item) => Number(item.media_section_id) === sectionId
				);

				if (!version) {
					return true;
				}

				const versionUrl = String(version.remote_url || '').split('?')[0];
				const parentUrl  = String(media.remote_url || '').split('?')[0];

				return !versionUrl || versionUrl === parentUrl;
			},
			determineFileSelect() {
				if (this.updatedMedia.status === 'pending' && Number(this.sectionInfo?.needs_approval) === 1) {
					return;
				}

				if (this.hasResizeDimensions) {
					if (this.sectionVersionNeedsCrop(this.updatedMedia)) {
						this.openCropper(this.updatedMedia);
					} else {
						this.selectMedia(this.updatedMedia);
					}
				} else {
					this.selectMedia(this.updatedMedia);
				}
			},
			selectMedia(media, rowIndex = null) {
				let url = this.$baseUri + '/Media/selectMediaFile/';

				const formData = new FormData();

				if (media.media_id) {
					formData.append('id', media.media_id);
				} else {
					formData.append('id', media.id);
				}

				if ( this.sectionInfo ) {
					formData.append('section', this.sectionInfo.internal_name);
				}

				// Pass the effective needs_approval (after URL override on sectionInfo)
				// so the server can overwrite the DB section flag for this request.
				if (typeof this.$needsApproval === 'boolean') {
					formData.append('needs_approval', Number(this.sectionInfo?.needs_approval) === 1 ? '1' : '0');
				}

				fetch(url, {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						console.log('select media response', data);

						if (data.status === 'pending') {
							this.updatedMedia = {
								...this.updatedMedia,
								status: data.status
							};

							if (this.needsPopFormForPending(data)) {
								this.showCropper = false;
								this.showPopForm = true;
								return;
							}

							if (this.sectionInfo?.vue_app === 1) {
								this.$emit('selected-media', data);
							} else {
								this.sendMediaToParent(data);
							}

							return;
						}

						if (this.sectionInfo.vue_app === 1) {
							this.$emit('selected-media', data);
							return;
						}

						this.sendMediaToParent(data);
					})
					.catch(error => {
						console.error('Error:', error);
					});
			},
			openCropper(file = null) {
				console.log('openCropper', file);
				this.uploadProps = {
					img        : file,
					mediaId    : this.updatedMedia.id,
					sectionInfo: this.sectionInfo,
				};

				this.showCropper = true;
				console.log('openCropper', this.uploadProps, this.showCropper);
			},
			closeModal() {
				this.showCropper = false;
			},
			emitCroppedSelection(version) {
				const selection = {
					status  : 'success',
					section : this.sectionInfo ? this.sectionInfo.internal_name : null,
					media_id: version.media_id,
				};

				this.closeModal();

				if (this.sectionInfo && Number(this.sectionInfo.vue_app) === 1) {
					this.$emit('selected-media', selection);
					return;
				}

				this.sendMediaToParent(selection);
			},
			emittedComponentData(fileData) {
				if (typeof fileData === 'string' && fileData === 'cancel-crop') {
					this.closeModal();
					return;
				}

				if (fileData && fileData.status === 'error') {
					this.openAlert(
						'error',
						'Error',
						fileData.message || 'Unable to save the cropped version of this file.'
					);
					return;
				}

				// saveMediaVersion already created/updated the section version — do not
				// call selectMediaFile, which would attach a metadata-only original.
				if (fileData && fileData.media_id && fileData.remote_url) {
					this.emitCroppedSelection(fileData);
					return;
				}

				this.openAlert('error', 'Error', 'Unable to save the cropped version of this file.');
			},
			getPopData() {
				if (!this.sectionInfo) {
					return;
				}

				fetch(`${this.$baseUri}/Media/getPopData/${this.media.id}`)
					.then(response => response.json())
					.then(data => {
						console.log('getPopData', data);
						if (data.status === 'success') {
							this.popData = data.pop_data;
						}
					})
					.catch(error => {
						console.error('Error:', error);
					});
			},
			handleClientUnlinked(eventData) {
				const mediaClients = this.updatedMedia.clients.filter(client => client.id !== eventData.client_id);
				const event = {
					media_id: eventData.media_id,
					clients : mediaClients
				};

				this.$emit('update-media-clients', event);
			},
			resolveVersionUrls() {
				if (!this.isImage || !Adzuki.MediaUrls || !Array.isArray(this.updatedMedia.versions)) {
					return;
				}

				Adzuki.MediaUrls.resolveVersions(this.updatedMedia.versions).catch((error) => {
					console.error('Error resolving media version urls:', error);
				});
			},
			/**
			 * A host app may not provide getMediaSrcString, or may provide a value
			 * instead of a function, so resolve the url locally in that case rather
			 * than letting the render throw.
			 */
			resolveMediaUrl(item) {
				if (typeof this.getMediaSrcString === 'function') {
					return this.getMediaSrcString(item);
				}

				if (item && item.remote_url) {
					return item.remote_url;
				}

				const fileName = (item && item.actual_file_name) || (item && item.original_file_name) || '';
				const path     = (item && item.path) || '';

				if (!path && !fileName) {
					return '';
				}

				return `${this.$baseUri}/${path}${fileName}`;
			},
			versionSrc(version) {
				return this.resolveMediaUrl(version);
			}
		},
		watch: {
			showEdit(editing) {
				this.editSnapshot = null;

				if (editing) {
					this.$nextTick(() => this.takeEditSnapshot());
				}
			},
			media(newMedia) {
				this.showClientLink = false;
				this.updatedMedia = newMedia;
				this.resolveVersionUrls();
			},
			viewElement: {
				immediate: true,
				flush    : 'post',
				handler(newValue) {
					console.log('Watch viewElement', newValue);
					if (newValue === 'cropper') {
						if (!this.updatedMedia) {
							this.$nextTick(() => this.openCropper(this.updatedMedia));
							return;
						}

						if (!this.showCropper) {
							console.log('updated Media', this.updatedMedia);
							this.openCropper(this.updatedMedia);
						}
					} else if (newValue === 'pop-form') {
						if (!this.updatedMedia) {
							this.$nextTick(() => {
								this.showPopForm = true;
							});
							return;
						}

						if (!this.showPopForm) {
							console.log('Show Pop Form', this.updatedMedia);
							this.showPopForm = true;
						}

					} else {
						this.showCropper = false;
						this.showPopForm = false;
					}
				}
			},
		},
		mounted() {
			if (this.$mediaId) {
				this.showEdit = true;
				this.$nextTick(() => this.takeEditSnapshot());
			}

			if (this.sectionInfo && this.media.id) {
				this.getPopData();
			}

			this.resolveVersionUrls();
		}
	};

	Adzuki.VueComponents.MediaHubDetails = component;
}(jQuery, window.Adzuki || {}));
